import { useQuery } from 'react-query';

import { getOpcProjectsList as queryFn } from 'api/endPoints/getOpcProjectsList';

export const useQueryGetOpcProjectsList = () => {
    return useQuery<queryResponse[], QueryError, queryResponse[]>({
        queryKey: ['getOpcProjectsList'],
        queryFn: () => queryFn(),
    });
};

interface queryResponse {
    projectOpcId: number;
    projectOpcName: string;
    workspaceOpcId: number;
}
